var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// 3rd-party imports

import React, { Component } from "react";

import PropTypes from "prop-types";

// component

var Offline = (_temp2 = _class = function (_Component) {
    _inherits(Offline, _Component);

    function Offline() {
        var _temp, _this, _ret;

        _classCallCheck(this, Offline);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            isOffline: !window.navigator.onLine,
            isOnline: window.navigator.onLine
        }, _this.handleOnline = function () {
            _this.handleEvent(false);
        }, _this.handleOffline = function () {
            _this.handleEvent(true);
        }, _this.handleEvent = function () {
            var isOffline = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            var isOnline = !isOffline;

            _this.props.onChange({ isOffline: isOffline, isOnline: isOnline });
            _this.setState({ isOffline: isOffline, isOnline: isOnline });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Offline.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener("online", this.handleOnline);
        window.addEventListener("offline", this.handleOffline);
    };

    Offline.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener("online", this.handleOnline);
        window.removeEventListener("offline", this.handleOffline);
    };

    Offline.prototype.render = function render() {
        var _props = this.props,
            children = _props.children,
            render = _props.render;


        if (render) {
            return render(this.state);
        }

        if (children) {
            if (typeof children === "function") {
                return children(this.state);
            }

            return React.Children.only(children)(this.state);
        }

        return null;
    };

    return Offline;
}(Component), _class.defaultProps = {
    render: null,
    onChange: function onChange() {}
}, _temp2);
export { Offline as default };
Offline.propTypes = process.env.NODE_ENV !== "production" ? {
    onChange: PropTypes.func,
    render: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.func])
} : {};